<!-- 数据的处理沿用 Favorite -->
<!-- 这里记录一下之前的一种布局方式，就是将下载描述为 ￥5/5积分 的方式，需要的比例是 14/14/14/19/39，如果不是则是标准的 15/15/15/15/40 -->
<template>
    <div style="display:inline-flex;align-items:center;width:100%;"> <!--向右挪动一点，否则看起来右侧很空-->
        <div style="width: 15%">
            <!-- 注意，使用 el-popconfirm 有两点注意事项，参考 Favorite.vue 中的描述 -->
            <el-popconfirm
                confirm-button-text='移除'
                confirm-button-type='danger'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="#909399"
                :disabled="!isLikeConfirm"
                @confirm="confirmUnLikes"
                :title="this.$store.getters.getDisplayMode().unlike.confirmMsg">
                <iconfont-selector-tooltip :is-actived="isLiked"  ref="likeSelector"
                                           default-class="iconfont icon-sy-love"
                                           actived-class="iconfont icon-sy-love-fill"
                                           actived-color="#ed4956"
                                           :font-size="30"
                                           :line-height="30"
                                           :tooltip-text="'点赞该'+type"
                                           :disabled="isLikeDisabled"
                                           slot="reference"
                                           @change="handleLikes"/>
            </el-popconfirm>
            <div style="font-size:12px;line-height:16px">喜欢</div>
        </div>
        <div style="width: 15%">
            <el-popconfirm
                confirm-button-text='移除'
                confirm-button-type='danger'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="#909399"
                :disabled="!isFavoriteConfirm"
                @confirm="confirmUnFavorites"
                :title="this.$store.getters.getDisplayMode().unfavorite.confirmMsg">
                <iconfont-selector-tooltip :is-actived="isFavorited"  ref="favoriteSelector"
                                           default-class="iconfont icon-sy-favorite"
                                           actived-class="iconfont icon-sy-favorite-fill"
                                           :font-size="26"
                                           :line-height="30"
                                           :tooltip-text="'收藏该'+type"
                                           :disabled="isFavoriteDisabled"
                                           slot="reference"
                                           @change="handleFavorite"/>
            </el-popconfirm>
            <div style="font-size:12px;line-height:16px">收藏</div>
        </div>
        <div style="width: 15%">
            <!-- 终于发现为什么 comments 打开延迟那么高了，是因为 iconfont-selector-tooltip 组件导致的，因此触屏端不需要使用它 -->
            <iconfont-selector-tooltip
                v-if="isWebAgent"
                :is-actived="true"
                default-class="el-icon-chat-round"
                actived-class="el-icon-chat-round"
                default-color="#2c3e50"
                actived-color="#2c3e50"
                :font-size="24"
                :line-height="28"
                :handler="showComments"
                tooltip-text="评论"/>
            <i v-else class="el-icon-chat-round" style="font-size:24px; line-height: 28px" @click="showComments"></i>
            <div style="font-size: 12px;line-height:16px;margin-top:2px">{{this.comments.length}}</div>
        </div>
        <!-- 如果没有积分挡道，就是 15/15/15/15/40 的布局-->
        <div style="width: 15%">
            <entity-download :e="e" />
        </div>
        <div style="width:40%;height:100%;font-size:13px;margin-top:6px">
            <div style="height:50%;margin-bottom: 4px"><span style="padding-right:6px;">{{e.likes.toLocaleString()}}</span><span class="font-gray">喜欢</span></div>
            <div style="height:50%;"><span class="font-gray">尺寸</span> {{e.width}} x {{e.height}}</div>
        </div>
        <!-- 评论弹出框组件：特别注意，el-drawer 在低端的 Android 上运行很慢 -->
        <el-drawer
            title="评论"
            append-to-body
            size="80%"
            :modal="false"
            :visible.sync="showCommentDrawer"
            :direction="commentDrawerDirection"
            :before-close="handleCommentDrawerClose"
            @open="commentDrawerOpen"
            @close="commentDrawerClose"
            @opened="commentDrawerOpened">
            <!--
             为了能够让 comment pannel 能够正常的滚动，必须正确的设置好 comment panel 的高度，计算逻辑如下
             1. 取得 drawer 的高度，window.innerHeight x 80%
             2. drawer 的表头固定是 45，评论提交区域固定是 100，因此得到 comment panel 的高度至少是 drawer 高度 - 表头高度 - 评论提交区域高度
             备注，#comment-panel 是在滑动到新增评论区域的时候需要使用到的，jquery 通过 id 准确找到 comment-panel 的起始位置。
            -->
            <div id="comment-panel" class="comment-panel" :style="{height: commentPanelHeight+'px'}">
                <comment ref="comment" :comments="comments" :avatar-size="32" v-if="hasComments"></comment>
                <div class="no-comment" v-else>
                    <div class="iconfont icon-sy-sofa"></div>
                    <div style="color: #909399; margin-left:4px">还没有评论，赶紧来抢沙发吧！</div>
                </div>
            </div>
            <div class="comment-input">
                <phone-input ref="input"></phone-input>
            </div>
        </el-drawer>
    </div>
</template>

<script>

    import {
        Entity,
        errorMessage,
        getCachedUser,
        getMaxScreenHeight,
        ShowEntityMode,
        Styles,
        warningMessage,
        loadingInstance,
        isPhoneAgent,
        isWebAgent,
        GlobalLoading
    } from "../../../utils";
    import {CachedApiSecurity} from "../../../api-security";
    import {likes, favorites} from "../../../data/user";
    import {vue} from "../../../main";
    import {getMainComments} from "../../../data/comment";
    import Comment from '../../../components/comments/Comment'
    import PhoneInput from '@/components/comments/PhoneInput'
    import EntityDownload from "../EntityDownload";

    export default {
        name: "PhoneFavorite",
        components: {
            EntityDownload,
            Comment,
            PhoneInput
        },
        props: {
            e: null,  // the entity
        },
        data() {
            return {
                isLiked: false,  // 用来控制喜欢 icon 的状态变化
                isLikeConfirm: false, // 发起喜欢操作是否需要 confirm？这个主要是针对 user likes center 的取消喜欢而设计的。
                isLikeDisabled: false,
                isFavorited: false, // 用来控制收藏 icon 的状态变化
                isFavoriteConfirm: false, // 同上
                isFavoriteDisabled: false,
                comments: [],
                commentPanelHeight: 0,   // 使用 caculateCommentPanelHeight() 方法动态计算得到
                showCommentDrawer: false,
                commentDrawerDirection: 'btt'
            }
        },
        computed: {
            // 资源的类别
            type(){
                return Entity.getType(this.e).name;
            },
            hasComments(){
                console.log(`hasComments, ${this.comments}`);
                return this.comments !== null && this.comments.length > 0 ? true: false;
            },
            isWebAgent(){
                return isWebAgent();
            }
        },
        mounted() {
            console.log('phone favorite mounted')
            this.initCommentPanelHeight();
            console.log(`the comment panel height caculcated as ${this.commentPanelHeight}`)
        },
        created() {
            this.init();
            // this -> 是 Favorite，下面的监听表示是 Favorite 组件监听。
            this.$EventBus.$on('signedin', () => {
                console.log('Favorite, caught the signedin global event');
                this.init();
            });
            this.$EventBus.$on('signout', () => {
                console.log('Favorite, caught the signout global event');
                this.init();
            });
            this.init_comments();
        },
        beforeDestroy() {
            // 说是（https://juejin.cn/post/6861572888420581390），在该组件被销毁的时候，需要移除该组件对该事件的监听。
            this.$EventBus.$off('signedin')
            this.$EventBus.$off('signout');
        },
        methods: {
            init(){
                console.log('Favorite init method get called~~~');
                if( CachedApiSecurity.isSignedIn() ){
                    this.isLiked = getCachedUser().likes.includes(this.e.shortcode);
                    this.isFavorited = getCachedUser().favorites.includes(this.e.shortcode);
                }else{
                    this.isLiked = false;
                    this.isFavorited = false;
                }
            },
            init_comments(){
                // TODO refactor the code, let Infoboard and PhoneInfoboard uses the same code.
                let mainComments = this.$store.getters.getComments(this.e.shortcode);
                if(mainComments !== undefined && mainComments !== null){
                    this.comments = mainComments;
                    console.log('comments loaded from cache:', this.comments);
                    // 2. then load from remote.
                }else{
                    this.loadingComments = true;
                    getMainComments.bind(this)(this.e.shortcode).then((comments)=>{
                        this.comments = comments;
                    }).catch((error)=>{
                        console.log(error);
                    }).finally(()=>{
                        this.loadingComments = false;
                    });
                }
            },
            /**
             * 为了能够让 comment pannel 能够正常的滚动，必须正确的设置好 comment panel 的高度，计算逻辑如下
               1. 取得 drawer 的高度，window.innerHeight x 80%
               2. drawer 的表头固定是 45，评论提交区域固定是 100，因此得到 comment panel 的高度至少是 drawer 高度 - 表头高度 - 评论提交区域高度
             */
            initCommentPanelHeight(){
                this.commentPanelHeight = getMaxScreenHeight()* 0.8 - 100 - 45
                this.commentPanelHeight = this.commentPanelHeight.toFixed(1);
                console.log(`the comment height is ${this.commentPanelHeight}`);
            },

            showComments() {
                // 现在 PC 端使用的也是 PhoneFavroite 控件，照理说 comments iconfont 不应该出现，但是现在懒得布局了，就这样吧，不响应它即可。
                if (isPhoneAgent()) {
                    // 增加 GlobalLoading 主要是为了兼容低端的 Android 手机...
                    GlobalLoading.start();
                    setTimeout(()=>{
                        this.showCommentDrawer = true;
                    }, 300)
                } else if(isWebAgent()){
                    // focus the input
                    console.log(this.$parent.$refs.input);
                    this.$parent.$refs.input.$refs.textarea.focus();
                }
            },

            handleCommentDrawerClose(done) {
                done();
                console.log('comments drawer get closed');
            },

            commentDrawerOpen(){
                console.log('comments drawer openning');
                Styles.disableBodyScroll();
            },

            // 在手机浏览器上，因为手机默认的底部状态栏有时候会消失，因此在 drawer 打开后，还需要动态的计算得出 comment 的高度，否则评论区域会留白。
            commentDrawerOpened(){
                // console.log('comments drawer opened')
                // this.calculateCommentPanelHeight();
                GlobalLoading.stop();
            },

            commentDrawerClose(){
                console.log('comments drawer closing');
                // fix a bug - 从用户喜欢的弹窗页面中 -> popup enity -> 点开评论 -> 关闭评论，这个时候，commentDrawerClose 会将
                // body scroll enable 而导致 MyDialog 的 body scroll disabled 失效。因此只有当 single page mode 的时候才需要
                // enable body scroll 其他情况由弹窗自己控制。
                if( this.$store.getters.getShowEntityMode() !== ShowEntityMode.PopupPageMode ){
                    Styles.enableBodyScroll();
                }

            },

            focusInput(){
                if( !CachedApiSecurity.isSignedIn() ){
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                }else{
                    console.log(this.$parent.$refs.input);
                    this.$parent.$refs.input.$refs.textarea.focus();
                }
            },

            /**
             * V2: 为 usercenter likes 新增 unlikes confirm 逻辑。目前这也是耦合性最强的代码逻辑，
             */
            handleLikes(isActived){
                console.log('handle like, isActived:', isActived);
                let isLikes = isActived;  // rename it to be more meaniful.
                // 提示用户必须登录才能操作
                if( !CachedApiSecurity.isSignedIn() ){
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                    this.revert("likeSelector");
                }else{
                    let mode = this.$store.getters.getDisplayMode();
                    if(!isLikes && mode.unlike.isNeedConfirm){
                        // ----------
                        // 专门为 user center likes 设计的逻辑 - unlike confirm
                        // ----------
                        console.log('likes confirm needed')
                        // 要特别注意，isLikeConfirm 只有在初始化的时候对 el-popconfirm 管用，之后如果再次设置 isLikeConfirm = false，
                        // 将会出现问题，因此这种方式目前只适合 user likes/favortes page
                        this.isLikeConfirm = true; // needs unlike confirm，弹出确认窗口，当用户 confirm 后回调 confirmLikes 方法继续后续处理
                        this.isLikeDisabled = true; // 禁用 likes iconfont selector 组件。
                        this.revert("likeSelector");  // 同时模拟图标 disabled 的场景。
                    }else{
                        this.__doLikes(isLikes);
                    }
                }
            },

            /**
             * 这个方法是专门为 user center likes 提供的，确认从喜欢列表中移除后的回调方法，
             */
            confirmUnLikes(){
                console.log('confirm unlikes');
                // this.isLiked = false;  // 因为移除有一个展示过程，将其状态改变为 unchecked 用户感觉更真实。
                // 因为 iconfont 已经被禁用了，所以上述的方式只能使用下面的 revert 方式替换了
                this.revert("likeSelector");
                this.__doLikes(false);  // 确定不喜欢了，因此这里的参数一定是 false;
            },

            /**
             * 向服务器发起异步请求更新状态
             */
            __doLikes(isLikes){
                // 因为 user likes 页面需要等待确定移除以后才能滑动到下一个 entity，因此这类需要添加等待。
                let loading = null;
                let mode = this.$store.getters.getDisplayMode();
                if(!isLikes && mode.unlike.isNeedConfirm) {
                    loading = loadingInstance();
                }
                let incNum = isLikes ? 1 : -1;
                this.e.likes += incNum; // 为了没有延迟，先直接增加，若后面异步远程提交遇到延迟，再回滚。
                likes(this.e.shortcode, isLikes).then(()=>{
                    console.log(`likes ${this.e.shortcode} remote return success`);
                    // Cache likes into client（因为选择不实时与服务器发生交互查询状态，因此必须将状态值实时同步到客户端缓存）
                    isLikes ?
                        this.$store.commit('addUserLikes', this.e.shortcode) :
                        this.$store.commit('removeUserLikes', this.e.shortcode)
                    // 处理移除喜欢列表中的 entity，发出"全局事件"，由 likes dialog 捕获，并回调 list 的 remove(e) 方法移除.
                    isLikes ? '' : vue.$EventBus.$emit('unlikes', this.e.shortcode);
                    // 这里是手机端的逻辑，直接关闭窗口，找到 PopupEntity 组件，然后调用它的 hide 方法进行关闭。
                    // @deprecated 后来发现不需要这么做，因为在 UserFavorLikes.vue 中通过设置 list.allowPopup = false 已经将它关闭了
                    // if(mode.unfavorite.isNeedConfirm){
                    //     let popupEntityComp = this.$parent.$parent.$parent;
                    //     console.log('phone favorite, do unlike, the popup entity component:', popupEntityComp);
                    //     popupEntityComp.hide();
                    // }
                }).catch((err)=>{
                    console.log(`likes ${this.e.shortcode} remote return failed, err: ${err}`);
                    errorMessage(err.message);
                    // 以下反向操作即可 - 即回滚。
                    this.e.likes -= incNum;
                    this.revert("likeSelector");
                    isLikes ?
                        this.$store.commit('removeUserLikes', this.e.shortcode) :
                        this.$store.commit('addUserLikes', this.e.shortcode)
                }).finally(()=>{
                    if(loading !== null){
                        loading.close();
                    }
                })
            },

            handleFavorite(isActived){
                console.log('handle follows_, isActived:', isActived);
                if( !CachedApiSecurity.isSignedIn() ){
                    CachedApiSecurity.handleNoAuthorith();
                    this.revert("favoriteSelector")
                }else{
                    let isFavorites = isActived;
                    let mode = this.$store.getters.getDisplayMode();
                    if(!isFavorites && mode.unfavorite.isNeedConfirm){ // unlike
                        // ----------
                        // 专门为 user center likes 设计的逻辑 - unlike confirm
                        // ----------
                        this.isFavoriteConfirm = true; // needs unlike confirm. confirm 后回调 confirmUnFavorites 方法继续后续处理
                        this.isFavoriteDisabled = true; // 禁用 iconfont selector
                        this.revert("favoriteSelector");  // 模拟图标 disabled 的场景
                    }else{
                        this.__doFavorites(isFavorites);
                    }
                }
            },

            /**
             * 这个方法是专门为 user center likes 提供的，确认从喜欢列表中移除后的回调方法，
             */
            confirmUnFavorites(){
                console.log('confirm unfavorites');
                // this.isFavorited = false;  // 因为移除有一个展示过程，将其状态改变为 unchecked 用户感觉更真实。
                // 因为 iconfont 已经被禁用了，所以上述的方式只能使用下面的 revert 方式替换了
                this.revert("favoriteSelector");
                this.__doFavorites(false);  // 确定不喜欢了，因此这里的参数一定是 false;
            },

            /**
             * @param {Boolean} isFavorites
             */
            __doFavorites(isFavorites){
                // 因为 user favorites 页面需要等待确定移除以后才能滑动到下一个 entity，因此这类需要添加等待。
                let loading = null;
                let mode = this.$store.getters.getDisplayMode();
                if(!isFavorites && mode.unfavorite.isNeedConfirm) {
                    loading = loadingInstance();
                }
                favorites(this.e.shortcode, isFavorites).then(()=>{
                    console.log(`favorites ${this.e.shortcode} remote return success`);
                    isFavorites ?
                        this.$store.commit('addUserFavorites', this.e.shortcode) :
                        this.$store.commit('removeUserFavorites', this.e.shortcode)
                    // 处理移除收藏列表中的 entity，发出"全局事件"，由 favorite dialog 捕获，并回调 list 的 remove(e) 方法移除.
                    isFavorites ? '' : vue.$EventBus.$emit('unfavorites', this.e.shortcode);
                }).catch((err)=>{
                    console.log(`likes ${this.e.shortcode} remote return failed`);
                    errorMessage(err.message);
                    // 反向操作
                    this.revert("favoriteSelector");
                    isFavorites ?
                        this.$store.commit('removeUserFavorites', this.e.shortcode) :
                        this.$store.commit('addUserFavorites', this.e.shortcode)
                }).finally(()=>{
                    if(loading !== null){
                        loading.close();
                    }
                });
            },

            /**
             *
             * @param selector, the selector ref name
             */
            revert(selector){
                this.$refs[selector].revert();
            }
        }
    }
</script>

<style scoped>

    /deep/ .el-drawer__header {
        margin-bottom: 10px;
    }

    /* 自定义 divider 的 margin */
    .el-divider--horizontal{
        height: 1px;
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .comment-panel{
        overflow: auto;
        font-size: 14px;
        padding: 15px;
    }

    .no-comment{
        display:flex;
        display:-webkit-flex;
        align-items:center;
        justify-content:center;
        margin-top:40px;width:100%;
    }

    @media (max-width: 320px){
        .comment-panel{
            padding: 10px;
        }
    }

    .comment-input{
        position: absolute;
        bottom: 0px;
        width: 100%;
    }


</style>



// WEBPACK FOOTER //
// src/components/entity/infoboard/PhoneFavorite.vue